module.exports = "./img/4e06c2123245f83c108b577be1d89225.jpg";